import styles from './ErrorContent.module.scss';
import { ErrorModalContent } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onConfirm(): void;
};

export const ErrorContent = ({ onConfirm }: Props) => {
  const errorMessage = useSelector(selectModalsErrors).createUserError;
  return (
    <ErrorModalContent
      title="User is not created"
      subtitle={`The user is not created${errorMessage ? `. ${errorMessage}` : ' because of technical errors'}`}
      contentContainerClassname={styles.errorModalContentContainer}
      buttonContainerClassname={styles.errorModalButtonContainer}
      onConfirm={onConfirm}
    />
  );
};
